import {createContext} from 'react'

const EspaciosAtencionContext = createContext()

export default EspaciosAtencionContext